import { render } from "./ProposalTemplateCreate.vue?vue&type=template&id=438550ef&scoped=true"
import script from "./ProposalTemplateCreate.vue?vue&type=script&lang=js"
export * from "./ProposalTemplateCreate.vue?vue&type=script&lang=js"

import "./ProposalTemplateCreate.vue?vue&type=style&index=0&id=438550ef&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438550ef"]])

export default __exports__